import { computed, Injectable, signal } from '@angular/core';
import { MlAdminUser, User } from '../model/user.model';

type CurrentUser = User & MlAdminUser;

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  #currentUser = signal<CurrentUser | null>(null);
  #currentTimeZone = signal<string | null>(null);

  currentUser = this.#currentUser.asReadonly();
  currentTimeZone = this.#currentTimeZone.asReadonly();
  currentUserPrivileges = computed(() => this.currentUser()?.privileges ?? []);

  // A Repairer user has no administrative privileges
  isRepairerUser = computed(
    () => !this.currentUserPrivileges().some((privilege) => ['REPADMIN', 'MLADMIN', 'SYSADMIN'].includes(privilege))
  );

  /*
   * Similar computed variables should be created for each type of User and their various combinations of privileges.
   * Privileges are checked individually throughout the app for different scenarios, when given the opportunity
   * to clarify these combinations they can be cleaned up and used here.
   * */

  constructor() {
    this.#currentUser.set(JSON.parse(sessionStorage.getItem('currentUser')));
    this.#currentTimeZone.set(sessionStorage.getItem('timeZone'));
  }

  get currentUserValue(): CurrentUser {
    return this.#currentUser();
  }

  get timeZone(): string {
    return this.#currentTimeZone();
  }

  set timeZone(value: string) {
    sessionStorage.setItem('timeZone', value);
    this.#currentTimeZone.set(value);
  }

  userLogin(user): void {
    sessionStorage.setItem('currentUser', JSON.stringify(user));
    this.#currentUser.set(user);
  }

  userLogout(): void {
    sessionStorage.removeItem('currentUser');
    this.#currentUser.set(null);
  }
}
